var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 420,
    viewBox: "0 0 420 420",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 420,
    height: 420,
    fill: "#FFE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.4583 207.127C88.4583 223.145 91.6132 239.006 97.7429 253.804C103.873 268.603 112.857 282.049 124.183 293.375C135.51 304.702 148.956 313.686 163.755 319.816C178.553 325.946 194.414 329.101 210.432 329.101C226.45 329.101 242.311 325.946 257.109 319.816C271.908 313.686 285.354 304.702 296.68 293.375C308.006 282.049 316.991 268.603 323.121 253.804C329.25 239.006 332.405 223.145 332.405 207.127L210.432 207.127H88.4583Z",
    fill: "#FDB52A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4583 85.1534C88.4583 101.171 91.6132 117.032 97.7429 131.831C103.873 146.629 112.857 160.075 124.183 171.402C135.51 182.728 148.956 191.712 163.755 197.842C178.553 203.972 194.414 207.127 210.432 207.127C226.45 207.127 242.311 203.972 257.109 197.842C271.908 191.712 285.354 182.728 296.68 171.402C308.006 160.075 316.991 146.629 323.121 131.831C329.25 117.032 332.405 101.171 332.405 85.1533L210.432 85.1534L88.4583 85.1534Z",
    fill: "#FF7D85"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOne);
export default __webpack_public_path__ + "static/media/one.91ccc8d6610397f00bdcce26b619b2f9.svg";
export { ForwardRef as ReactComponent };